var twitter_slider = (function ( $ ) {

	var $carousel = null;

	var _init = function () {
		$carousel = $( '#twitter-slider' ).find( '.owl-carousel' );

		_setup_slider();
	};

	var _setup_slider = function () {
		$carousel.on( 'initialized.owl.carousel', _slider_initialised );

		$carousel.owlCarousel( {
			items: 1,
			loop: true,
			nav: false,
			dots: true,
			autoplay: true
		} );
	};

	var _slider_initialised = function( event ) {
		$carousel.find( '.owl-item .item' ).show();
	};

	if ( $( '#twitter-slider' ).length > 0 ) {
		$( document ).ready( _init );
	}

	return {};

})( jQuery );

module.exports = twitter_slider;